/* eslint-disable react/prop-types */
import MyImage from '@shared/components/myImage'
import React from 'react'
import styles from './style.module.scss'
import s1Image from '@assets/images/hil/s1.jpeg'
import s2Image from '@assets/images/hil/s2.jpg'
import location from '@assets/images/hil/location.svg'
import people from '@assets/images/hil/people.svg'
import CustomLink from '@shared/components/customLink'

function VenueMweb({ isMobile = false }) {
  return (
    <div className={styles.venueContainer}>
      <div className="w-100 d-flex flex-column justify-content-between align-item-center gap-2">
        <div className="w-100 d-flex justify-content-center">
          <MyImage src={s1Image} alt="Stadium Image" height={115} width={200} className={styles.stadiumImage} />
        </div>
        <div className="w-100">
          <CustomLink
            href={
              isMobile ? 'https://www.oneturf.news/hockey/hockey-india-league-all-about-the-birsa-munda-hockey-stadium-in-rourkela/mobile' : 'https://www.oneturf.news/hockey/hockey-india-league-all-about-the-birsa-munda-hockey-stadium-in-rourkela'
            }>
            <div className={`${styles.stadiumTitle}`}>Birsa Munda International Hockey stadium</div>
          </CustomLink>
          <div className="d-flex justify-content-center gap-2 mt-2">
            <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
              <MyImage src={location} className={styles.loImg} />
              <p className="mb-0">Rourkela</p>
            </div>
            <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
              <MyImage src={people} className={styles.loImg} />
              <p className="mb-0">20,011</p>
            </div>
          </div>
        </div>
      </div>
      <div className="w-100 d-flex flex-column justify-content-between align-item-center gap-2">
        <div className="w-100 d-flex justify-content-center">
          <MyImage src={s2Image} alt="Stadium Image" height={115} width={200} className={styles.stadiumImage} />
        </div>
        <div className="w-100">
          <CustomLink
            href={
              isMobile ? 'https://www.oneturf.news/hockey/hockey-india-league-2024-all-about-marang-gomke-jaipal-singh-astroturf-hockey-stadium/mobile' : 'https://www.oneturf.news/hockey/hockey-india-league-2024-all-about-marang-gomke-jaipal-singh-astroturf-hockey-stadium'
            }>
            <div className={`${styles.stadiumTitle}`}>Marang Gomke Jaipal Singh Astro Turf Hockey Stadium</div>
          </CustomLink>
          <div className="d-flex justify-content-center gap-2 mt-2">
            <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
              <MyImage src={location} alt="Location" className={styles.loImg} />
              <p className="mb-0">Ranchi</p>
            </div>
            <div className={`d-flex justify-content-between align-items-center w-100 ${styles.location}`}>
              <MyImage src={people} alt="People" className={styles.loImg} />
              <p className="mb-0">5000</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default VenueMweb
